module.exports = __webpack_public_path__ + "officialStatic/img/zhongheLogo.00f2593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/zhongheLogo.png
// module id = d56J
// module chunks = 0